export const experienceData = [
    {
        id: 1,
        company: 'HYPE Design Studio',
        jobtitle: 'Professional Freelancer',
        startYear: '2016',
        endYear: 'Present',
        desc1: 'Conceptualizes new designs for marketing materials and ads.',
        desc2: 'Designed a new menu design layout for Ombak Kitchen.',
        desc3: 'Designed a logo for Warung Sepakat with vintage ‘Melayu’ theme.',
        desc4: 'Designed a bottle mockup, poster and advertising flyers for Kartel Ink.',
    },
    {
        id: 2,
        company: 'Quiware Sdn Bhd',
        jobtitle: 'Graphic Designer',
        startYear: '2020',
        endYear: '2020',
        desc1: 'Developed collateral such as display, marketing and packaging materials to support product branding strategies.',
        desc2: 'Developed creative design for marketing packages, including print materials, brochures, banners and signs.',
        desc3: 'Researched trends and projected changes in Food & Beverage in order to capitalize on product design style.',
        desc4: 'Met with customers to present mockups and collect information for adjustments. ',
    },
    {
        id: 3,
        company: 'Natugee Sdn Bhd',
        jobtitle: 'Creative Creator',
        startYear: '2019',
        endYear: '2019',
        desc1: 'Plan and execute all digital marketing, including social media and display advertising campaigns.',
        desc2: 'Designed Instagram Stories with graphic motion and executed email marketing with email sequences using MailChamp.',
        desc3: 'Designing and content creating for campaign, advertising and internal materials.',
        desc4: 'Managing content and solving few errors in website.',
    },
]